import {
  TOGGLE_MENU,
  HTTP_REQUEST,
  SUBMIT_URL,
  FEATURED_URL,
  FEEDBACK_URL,
  FEATURED_REQUEST_INIT,
  FEATURED_REQUEST_SUCCESS,
  FEATURED_REQUEST_ERROR,
  SELECT_CHARITY,
  DETAILS_ADD_FIELD,
  DETAILS_DELETE_FIELD,
  DETAILS_ONCHANGE,
  DETAILS_ONBLUR,
  MESSAGE_ONCHANGE,
  PAYMENT_ONCHANGE,
  PAYMENT_ONBLUR,
  ZIP_URL,
  HTTP_SUCCESS,
  HTTP_ERROR,
  DONATION_REQUEST_INIT,
  DONATION_REQUEST_SUCCESS,
  DONATION_REQUEST_ERROR,
  RESET_GLOBAL_STATE,
  DEFAULT_AMOUNT,
  DEFAULT_RETURN_AMOUNT,
  RESPONSE_URL,
  RESPONSE_FETCH_REQUEST,
  RESPONSE_FETCH_SUCCESS,
  RESPONSE_FETCH_ERROR,
  FEEDBACK_REQUEST,
  FEEDBACK_SUCCESS,
  FEEDBACK_ERROR
} from "../constants/constants.js";

import { push } from "react-router-redux";

import axios from "axios";

export function toggleMenu() {
  return {
    type: TOGGLE_MENU
  };
}

export const fetchCharities = dispatch => {
  return dispatch => {
    dispatch({
      type: FEATURED_REQUEST_INIT
    });
    axios
      .get(FEATURED_URL)
      .then(response =>
        dispatch({
          type: FEATURED_REQUEST_SUCCESS,
          payload: response.data
        })
      )
      .catch(err => dispatch({ type: FEATURED_REQUEST_ERROR, error: err }));
  };
};

export function selectCharity(charity) {
  return {
    type: SELECT_CHARITY,
    payload: charity
  };
}

export function detailsAddField(currentPage, section) {
  return {
    type: DETAILS_ADD_FIELD,
    payload: { currentPage, section }
  };
}

export function detailsDeleteField(currentPage, section, idx) {
  return {
    type: DETAILS_DELETE_FIELD,
    payload: { currentPage, section, idx }
  };
}

export function detailsFieldOnChange(currentPage, section, value, idx) {
  return {
    type: DETAILS_ONCHANGE,
    payload: { currentPage, section, value, idx }
  };
}

export function detailsFieldOnBlur(currentPage, section, value, idx) {
  return {
    type: DETAILS_ONBLUR,
    payload: { currentPage, section, value, idx }
  };
}

export function messageFieldOnChange(value) {
  return {
    type: MESSAGE_ONCHANGE,
    payload: value
  };
}

export function paymentFieldOnChange(section, field, value) {
  return {
    type: PAYMENT_ONCHANGE,
    payload: { section, field, value }
  };
}

export const paymentFieldOnBlur = (section, field, value) => dispatch => {
  if (field === "bill_zip") {
    dispatch({
      type: HTTP_REQUEST
    });
    axios(ZIP_URL + value)
      .then(response => {
        const { city, state_short } = response.data;
        dispatch({
          type: HTTP_SUCCESS
        });
        dispatch({
          type: PAYMENT_ONBLUR,
          payload: { section, field, value }
        });
        dispatch({
          type: PAYMENT_ONBLUR,
          payload: { section, field: "bill_city", value: city }
        });
        dispatch({
          type: PAYMENT_ONBLUR,
          payload: { section, field: "bill_state", value: state_short }
        });
      })
      .catch(error =>
        dispatch({
          type: HTTP_ERROR,
          error
        })
      );
  } else {
    return dispatch({
      type: PAYMENT_ONBLUR,
      payload: { section, field, value }
    });
  }
};

export const submitDonation = details => dispatch => {
  let matching = {
    firstName: "firstNames",
    lastName: "lastNames",
    email: "Emails",
    phone: "Phones"
  };
  let payload = {
    attemptId: details.transactionId,
    payment: {},
    charity: details.charity,
    personDetails: {},
    targetDetails: {},
    returnAmount: DEFAULT_RETURN_AMOUNT,
    amount: DEFAULT_AMOUNT,
    message: details.message
  };
  payload.payment.amount = DEFAULT_AMOUNT;
  payload.payment.token = details.payment.token.fields.token.value;
  Object.keys(details.personal).map(field => {
    if (field === "valid") return false;
    let key = matching[field];
    payload.personDetails[key] = [];
    details.personal[field].map((fieldValue, idx) => {
      payload.personDetails[key].push({
        label: `${key}${idx}`,
        value: fieldValue.value,
        valid: fieldValue.valid
      });
    });
  });

  Object.keys(details.target).map(field => {
    if (field === "valid") return false;
    let key = matching[field];
    payload.targetDetails[key] = [];
    details.target[field].map((fieldValue, idx) => {
      payload.targetDetails[key].push({
        label: `${key}${idx}`,
        value: fieldValue.value,
        valid: fieldValue.valid
      });
    });
  });
  dispatch({
    type: DONATION_REQUEST_INIT
  });

  axios
    .post(SUBMIT_URL, payload)
    .then(response => {
      dispatch({
        type: DONATION_REQUEST_SUCCESS,
        payload: response.data
      });
    })
    .catch(e =>
      dispatch({
        type: DONATION_REQUEST_ERROR,
        error: JSON.stringify(e)
      })
    );
};

export function resetState() {
  return {
    type: RESET_GLOBAL_STATE
  };
}

export const fetchResponse = detailsId => dispatch => {
  dispatch({
    type: RESPONSE_FETCH_REQUEST
  });
  axios(RESPONSE_URL + detailsId)
    .then(response => {
      dispatch({
        type: RESPONSE_FETCH_SUCCESS,
        payload: response.data
      });
    })
    .catch(e => {
      dispatch({
        type: RESPONSE_FETCH_ERROR,
        error: JSON.stringify(e)
      });
      dispatch(push("/"));
    });
};

export const submitFeedback = payload => dispatch => {
  dispatch({
    type: FEEDBACK_REQUEST
  });
  axios
    .post(FEEDBACK_URL, payload)
    .then(respose =>
      dispatch({
        type: FEEDBACK_SUCCESS
      })
    )
    .catch(err =>
      dispatch({ type: FEEDBACK_ERROR, error: JSON.stringify(err) })
    );
};



// WEBPACK FOOTER //
// ./actions/actions.js